import { render, staticRenderFns } from "./ChangelogEntryItem.vue?vue&type=template&id=6812e4e9&scoped=true&"
import script from "./ChangelogEntryItem.vue?vue&type=script&lang=js&"
export * from "./ChangelogEntryItem.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogEntryItem.vue?vue&type=style&index=0&id=6812e4e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812e4e9",
  null
  
)

export default component.exports